import './onboardingStakeHolderDetails.css';
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';

import { SAVE_INTERNAL_STAKEHOLDER, All_ONBOARD_STAKEHOLDER_ROLE } from '../../../common/URLs';
import { GENDER, GOV_ID_LIST_USER, HELPDESK_ROLES, QUALITY_ROLES, RESOURCE_ROLES, SALUTATION } from '../../../common/constants';
import resolveIcon from "../../../images/resolved.png";
import { sendOTP, validateOTP } from '../../../common/Utils';
import { MOBILE_NO_ERROR, INVALID_OTP_ERROR, ROLES, PIT_ROLES, STAKEHOLDERTYPE } from '../../../common/constants';
import { authKey, GET_ALL_USERS, GET_USER, ALL_MODULE_ROLES } from '../../../common/URLs';
import { loaderService } from '../../../common/custom-loader/loader-service';
import DeleteIcon from '@mui/icons-material/Delete';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { PROD } from "../../../common/constants";
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { Switch } from 'antd';
import { Container, Card, Checkbox, Link, CardContent, IconButton, Button, Tab, Stack, Box, Typography, Grid, FormControl, RadioGroup, Radio, FormGroup, FormLabel, FormControlLabel, InputLabel, Select, MenuItem, TextField, Tooltip } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { Row, Col } from 'react-bootstrap';
import { emailUrnPassMaxLength, lastFourDigit, maxNameLength, mobileNoMaxLength, VALIDATION } from '../../../common/commonValidations';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { handleNumberFieldFocus } from '../../../common/commonFunction';
import { useData } from '../../../App';
import { sendSignupLink } from '../../../common/Utils';
import { stakeholderType } from '../../../common/spinLoader';
import { FileUploadMUI } from "../../../common/fileUpload/fileUploadMUI";
import { CloseIcon, EditIcon, ResetPasswordIcon, SignuplinkIcon, SubmitIcon, UpdateIcon } from '../../../common/icons';
import BadgeComponent from '../../../common/badge';
import apiClient from '../../../axios';

const OnboardingStakeHolderDetails = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const shoullog = useRef(true);
    const [userId, setUserId] = useState()
    const [mobileOTPValidated, setMobileOTPValidated] = useState(false);
    const [otpHidden, setOtpHidden] = useState(true);
    const [otpValue, setOtpValue] = useState()
    const [verifyMobileNo, setVerifyMobileNo] = useState(false);
    const [pincodeAddressDetails, setPincodeAddressDetails] = useState();
    const [showGrid, setShowGrid] = useState(true);
    const [showForm, setShowForm] = useState('');
    const [userDetails, setUserDetails] = useState([]);

    const [updateUserDetails, setUpdateUserDetails] = useState();
    const stakeholderCategory = getLocalStorageItem("stakeholderCategory");
    const { loginUserDetails } = useData();
    const [details, setDetails] = useState({
        salutation: 'Mr',
        firstname: '',
        middlename: '',
        lastname: '',
        mobileNo: '',
        gender: 'Male',
        emailAddress: '',
        address: '',
        pincode: '',
        govtIdProofType: 'Aadhaar ID',
        govtIdProofNumber: '',
        id: '',
        selectedPersonalRevenueCircle: '',
        selectedPersonalBlockList: '',
        state: '',
        district: '',
        isActive: '',
        createdOn: '',
        createdBy: '',
        documents: [],
        userType: "External"
    });

    let [RollDetails, setRollDetails] = useState([]);
    const [errorMessage, setErrorMessage] = useState({
        fullNameError: '',
        contactPersonNameError: '',
        contactPersonMiddleNameError: '',
        contactPersonLastNameError: '',
        mobileNoError: '',
        pincodeError: '',
        searchError: '',
        emailIdError: '',
        addressError: '',
        govtIdCardNumberError: '',
        govtIdNoErr: '',
        govtIdTypeErr: '',
        roleError: '',
        idProofDocError: ''
    });
    const [updatedDetails, setUpdatedDetails] = useState({
        id: '',
        isActive: ''
    });
    const [disabledval, setDisabledval] = useState(false);
    const [checkedval, setCheckedval] = useState(false);
    const [usersToBeDeleted, setUsersToBeDeleted] = useState([]);
    const [userApiData, setUserApiData] = useState();
    const [selected, setSelected] = useState();
    const [allRoles, setAllRoles] = useState();
    const [activeUser, setActiveUser] = useState();
    const [logModalOpen3, setLogModalOpen3] = useState(false);
    const handleConfirmLogModalClose = () => setLogModalOpen3(false);
    const handleLogModalOpen3 = () => setLogModalOpen3(true);
    const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
    const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
    const handleConfirmLogModalClose3 = () => setLogConfirmModalOpen(false);
    const [userSaveResponse, setUserSaveResponse] = useState();

  const [clipboardContent, setClipboardContent] = useState('');
  const [error, setError] = useState('');

  const handleReadClipboard = async () => {
    try {
      if (navigator.clipboard && navigator.clipboard.readText) {
        const text = await navigator.clipboard.readText();
        setClipboardContent(text);
        console.log("clipboardText:"+text);
        setError(''); // Clear any previous errors
      } else {
        setError('Clipboard API not supported in this browser or context.');
      }
    } catch (err) {
      console.error('Failed to read clipboard contents:', err);
      setError('Failed to read clipboard: ' + err.message);
    }
  };

    useEffect(() => {
        if (userId) {
            //getUserDetails();
            var user = userDetails?.filter(item => item.id == userId)[0];
            setDetails(user);
 
        }
    }, [userId]);

    //function getUserDetails() {
    //    apiClient
    //        .post(GET_USER,
    //            {
    //                "userID": userId

    //            },
    //            {
    //                headers: {
    //                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
    //                }
    //            }, null
    //        )
    //        .then((response) => {
    //            setDetails(response.data.user);
    //        })
    //        .catch(function (error) {
    //            console.log(error);
    //        });
    //}

    useEffect(() => {
        if (shoullog.current) {
            shoullog.current = false;
            gellAllOnboardedRole();
        }
        if (userSaveResponse) {
            if (!(userSaveResponse.user)) {
                toast.error(userSaveResponse?.message);
            }
            else {
                toast.success(userSaveResponse?.message);
                setShowGrid(true);
                setShowForm('');
                getAllUsers();
            }
        }

    }, [userSaveResponse]);
    useEffect(() => {
        if (updateUserDetails) {
            if (!(updateUserDetails.user)) {
                toast.error(updateUserDetails?.message)
            }
            else {
                toast.success(updateUserDetails?.message)
                getAllUsers();
            }
        }

    }, [updateUserDetails]);
    const confirmDelete = (e, selected) => {
        e.preventDefault();
        setSelected(selected)
        handleLogModalOpen3();

    }

    const checkBoxHandleChange = (parentIndex, childIndex, checkedValue) => {
        const updatedData = [...allRoles]
        updatedData[parentIndex].RolesDetails[childIndex].checked = !checkedValue
        setAllRoles(updatedData)
    }

    function getAllModuleRoles() {
        loaderService.showLoader();
        apiClient
            .post(ALL_MODULE_ROLES,
                {
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                if (stakeholderCategory == STAKEHOLDERTYPE.LLE || stakeholderCategory == STAKEHOLDERTYPE.InterimStorageOperator) {
                    setAllRoles(response.data.lstModulesWithRolesMaster.filter((filterItem) => filterItem.parentModuleName === "PIT").map((item) => ({
                        moduleName: item?.parentModuleName,
                        RolesDetails: item?.childRolesName.filter((filterItem) => filterItem.childRolesName === PIT_ROLES.PitWeighbridgeOperator || filterItem.childRolesName === PIT_ROLES.PitUnloader || filterItem.childRolesName === PIT_ROLES.Loader).map((child) => ({
                            ...child,
                            checked: false, // Add the 'checked' property with an initial value
                            roleType: child.roleType
                        })),
                    })))
                }
                else if (getLocalStorageItem("role") == ROLES.RegInCharge) {
                    setAllRoles(response.data.lstModulesWithRolesMaster.filter((filterItem) => filterItem.parentModuleName === "Registration").map((item) => ({
                        moduleName: item?.parentModuleName,
                        RolesDetails: item?.childRolesName.filter((filterItem) => filterItem.childRolesName != ROLES.ItAdmin && filterItem.childRolesName != ROLES.RegInCharge && filterItem.childRolesName != ROLES.SCMInCharge).map((child) => ({
                            ...child,
                            checked: false, // Add the 'checked' property with an initial value
                            roleType: child.roleType
                        })),
                    })))
                }
                else if (getLocalStorageItem("role") == ROLES.RegSuperVisor) {
                    setAllRoles(response.data.lstModulesWithRolesMaster.filter((filterItem) => filterItem.parentModuleName === "Registration").map((item) => ({
                        moduleName: item?.parentModuleName,
                        RolesDetails: item?.childRolesName.filter((filterItem) => filterItem.childRolesName === ROLES.RegistrationScruitnizer || filterItem.childRolesName === ROLES.RegAssistant).map((child) => ({
                            ...child,
                            checked: false, // Add the 'checked' property with an initial value
                            roleType: child.roleType
                        })),
                    })))
                }
                else if (getLocalStorageItem("role") == ROLES.UserOnboarding) {
                    setAllRoles(response.data.lstModulesWithRolesMaster.map((item) => ({
                        moduleName: item?.parentModuleName,
                        RolesDetails: item?.childRolesName.filter((filterItem) => filterItem.childRolesName !== ROLES.ItAdmin && filterItem.childRolesName !== ROLES.UserOnboarding && filterItem.childRolesName !== ROLES.SCMInCharge && filterItem.childRolesName !== QUALITY_ROLES.Processing
                            && filterItem.childRolesName !== HELPDESK_ROLES.ExternalAdminUser && filterItem.childRolesName !== HELPDESK_ROLES.ExternalSupportExecutive && filterItem.childRolesName !== HELPDESK_ROLES.GuestUser).map((child) => ({
                                ...child,
                                checked: false, // Add the 'checked' property with an initial value
                                roleType: child.roleType
                            })),
                    })))
                }
                else if (getLocalStorageItem("role") == RESOURCE_ROLES.ResSupervisor) {
                    setAllRoles(response.data.lstModulesWithRolesMaster.filter((filterItem) => filterItem.parentModuleName === "Resource").map((item) => ({
                        moduleName: item?.parentModuleName,
                        RolesDetails: item?.childRolesName.filter((filterItem) => filterItem.childRolesName === RESOURCE_ROLES.ResourceScrutinizer).map((child) => ({
                            ...child,
                            checked: false, // Add the 'checked' property with an initial value
                            roleType: child.roleType
                        })),
                    })))
                }
                else {
                    setAllRoles(response.data.lstModulesWithRolesMaster.map((item) => ({
                        moduleName: item?.parentModuleName,
                        RolesDetails: item?.childRolesName.map((child) => ({
                            ...child,
                            checked: false, // Add the 'checked' property with an initial value
                            roleType: child.roleType
                        })),
                    })))
                }
                loaderService.hideLoader();
            })

            .catch(function (error) {
                loaderService.hideLoader();
            });
    }
    function gellAllOnboardedRole() {

        apiClient
            .post(All_ONBOARD_STAKEHOLDER_ROLE,
                {

                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                const rolesArray = response.data.roles;
                if (response.data.message === "Success") {
                    if (rolesArray.length > 0) {
                        rolesArray.map(item => {
                            RollDetails.push(
                                {
                                    id: item?.id,
                                    rollName: item?.roleName,
                                }
                            );

                        });
                    }

                }

            })
            .catch(function (error) {
            });
    }

    const onUploadCallBack = (docArray) => {

        setDetails({ ...details, documents: docArray });
    }
    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }

    const handleChange = (e) => {
        setDetails({ ...details, [e.target.name]: e.target.value })
        if (e.target.name === "address") {
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, addressError: "" })
            } else {
                setErrorMessage({ ...errorMessage, addressError: "Please enter Address" })

            }
        }
        if (e.target.name === "emailAddress") {
            if ((e.target.value).length > 0) {
                if (isValidEmail(e.target.value)) {
                    setErrorMessage({ ...errorMessage, emailIdError: "" })
                } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter valid Email address" })
            } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter Email address" })
        }
        if (e.target.name === "firstname") {
            setDetails({ ...details, [e.target.name]: e.target.value.replace(/[^a-z]/gi, '') })
            if ((e.target.value).length > 0) {
                const firstname_regex = /^[a-zA-Z]+$/;
                if (!((e.target.value).match(firstname_regex))) {
                    setErrorMessage({ ...errorMessage, contactPersonNameError: "Please provide valid Name" })
                } else setErrorMessage({ ...errorMessage, contactPersonNameError: "" })
            } else {
                setErrorMessage({ ...errorMessage, contactPersonNameError: "Please enter First Name" })

            }
        }
        if (e.target.name === "middlename") {
            setDetails({ ...details, [e.target.name]: VALIDATION.fullNameValidation(e.target.value) })
        }
        if (e.target.name === "lastname") {
            setDetails({ ...details, [e.target.name]: VALIDATION.fullNameValidation(e.target.value) })

        }
        if (e.target.name === "mobileNo") {
            const limit = 10;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            if ((e.target.value).length < 10) {
                setErrorMessage({ ...errorMessage, mobileNoError: "Please enter 10 digit mobile number" });
            }
            else setErrorMessage({ ...errorMessage, mobileNoError: "" });

        }
        if (e.target.name == "govtIdProofType") {
            setDetails({ ...details, govtIdProofNumber: "", [e.target.name]: e.target.value })
        }
        if (e.target.name === "govtIdProofNumber") {
            const limit = 4;
            const idlimit = 20;
            if (details.govtIdProofType === "Aadhaar ID") {
                setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            }
            else {
                setDetails({ ...details, [e.target.name]: e.target.value.toUpperCase().slice(0, idlimit) })
            }
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, govtIdCardNumberError: '' })
            }

        }
        if (e.target.name === "pincode") {
            const limit = 6;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            if ((e.target.value).length < 6) {
                setErrorMessage({ ...errorMessage, pincodeError: "Please enter 6 digit pincode" });
            }
            else setErrorMessage({ ...errorMessage, pincodeError: "" });
        }
    }

    const onClickVerifyMobileNo = (e) => {
        e.preventDefault();
        setErrorMessage({ ...errorMessage, OTPError: "" });
        setOtpValue("");
        if (isValidMobileNumber(details.mobileNo)) {
            sendOTP(details.mobileNo, callBackMobileValidation);
            setErrorMessage({ ...errorMessage, mobileNoError: "" });
        }
        else
            setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
    }
    const callBackMobileValidation = (response) => {
        setErrorMessage({ ...errorMessage, mobileNoError: "" });
        if (response.isSuccess) {
            setErrorMessage({ ...errorMessage, OTPSentError: "" })
            setErrorMessage({ ...errorMessage, mobileNoError: "" });
            setVerifyMobileNo(true);
            setOtpHidden(false);
            setErrorMessage({ ...errorMessage, OTPError: "" });
        }

    }
    const onOtpChange = (e) => {
        const limit = 6;
        setOtpValue(e.target.value.slice(0, limit))
        if (e.target.value.length == 6) {
            validateOTP(details.mobileNo, e.target.value, callBackOTPValidation);
        }
    }
    const callBackOTPValidation = (response) => {
        setErrorMessage({ ...errorMessage, OTPSentError: "" });
        setErrorMessage({ ...errorMessage, mobileNoError: "" });
        if (response.isSuccess === true) {
            setVerifyMobileNo(false);
            setOtpHidden(true);
            setMobileOTPValidated(true);
            setErrorMessage({ ...errorMessage, OTPError: "" });
            setErrorMessage({ ...errorMessage, mobileNoError: "" });
        }
        else {
            setErrorMessage({ ...errorMessage, mobileNoError: INVALID_OTP_ERROR });
        }
    }
    const isValidMobileNumber = (mobileNo) => {
        if (mobileNo.length == 10) {
            return true;
        }
        return false;
    }
    function updateUser() {
        apiClient
            .post(SAVE_INTERNAL_STAKEHOLDER,
                {
                    "abrplUser": {
                        "id": details?.id,
                        "salutation": details.salutation ? details.salutation : 'Mr',
                        "gender": details.gender ? details.gender : 'Male',
                        "firstname": details?.firstname,
                        "middlename": details?.middlename,
                        "lastname": details?.lastname,
                        "address": details?.address,
                        "pincode": details?.pincode,
                        "state": pincodeAddressDetails?.addresses[0]?.state,
                        "district": pincodeAddressDetails?.addresses[0]?.district,
                        "govtIdProofType": details?.govtIdProofType,
                        "govtIdProofNumber": details?.govtIdProofNumber,
                        "mobileNo": details?.mobileNo,
                        "emailAddress": details?.emailAddress,
                        "isActive": details?.isActive ? details?.isActive : updatedDetails?.isActive,
                        "userRoles": allRoles
                            ?.flatMap((parent) => parent.RolesDetails)
                            ?.filter((child) => child.checked)
                            ?.map((child) => ({ roleID: child.roleId, roleName: child.childRolesName })),
                        "sendSignupLink": ((getLocalStorageItem("role") != ROLES.ItAdmin)) ? false : true,
                        "createdOn": details?.createdOn,
                        "createdBy": details?.createdBy,
                        "documents": details?.documents,
                        "userType": details?.userType
                    },
                    "loginUserRole": getLocalStorageItem('role'),
                    "loginUserID": getLocalStorageItem('uuid') ? getLocalStorageItem('uuid') : ''
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                },
            )
            .then((response) => {
                if (!response.data.isSuccess && response.data.message.indexOf("mobile number") >= 0) {
                    setVerifyMobileNo(false);
                    setMobileOTPValidated(false);
                }
                setUserSaveResponse(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    function createUser() {
        apiClient
            .post(SAVE_INTERNAL_STAKEHOLDER,
                {
                    "abrplUser": {
                        "salutation": details.salutation ? details.salutation : 'Mr',
                        "gender": details.gender ? details.gender : 'Male',
                        "firstname": details.firstname,
                        "middlename": details.middlename,
                        "lastname": details.lastname,
                        "address": details.address,
                        "pincode": details.pincode,
                        "state": pincodeAddressDetails?.addresses[0]?.state,
                        "district": pincodeAddressDetails?.addresses[0]?.district,
                        "govtIdProofType": details?.govtIdProofType,
                        "govtIdProofNumber": details?.govtIdProofNumber,
                        "mobileNo": details.mobileNo,
                        "emailAddress": details.emailAddress,
                        "isActive": 1,
                        "userRoles": allRoles
                            ?.flatMap((parent) => parent.RolesDetails)
                            ?.filter((child) => child.checked)
                            ?.map((child) => ({ roleID: child.roleId, roleName: child.childRolesName })),
                        "sendSignupLink": ((getLocalStorageItem("role") != ROLES.ItAdmin)) || stakeholderCategory == STAKEHOLDERTYPE.LLE || stakeholderCategory == STAKEHOLDERTYPE.InterimStorageOperator ? false : true,
                        "documents": details?.documents,
                        "userType": details?.userType
                    },
                    "loginUserRole": getLocalStorageItem('role'),
                    "loginUserID": getLocalStorageItem('uuid') ? getLocalStorageItem('uuid') : ''
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                },
            )
            .then((response) => {
                if (!response.data.isSuccess && response.data.message.indexOf("mobile number") >= 0) {
                    setVerifyMobileNo(false);
                    setMobileOTPValidated(false);
                }
                setUserSaveResponse(response.data);

            })
            .catch(function (error) {
                console.log(error);
            });
    }
    const resetPwBtn = (e, params) => {
        navigate('/forgotPasswordscreen/abrpluser', {
            state: { selectedRow: params }

        });
    }
    const onSendSignUpLink = (e, params) => {
        var email = params?.emailAddress;
        sendSignupLink(email, sendSignUpCallback);
    }
    const sendSignUpCallback = (response) => {
        toast.success(response?.message);
    }
    const onPrevious = (e) => {
        e.preventDefault();
        setShowGrid(true);
        setShowForm('');
        allRoles.forEach((parent) => {
            parent.RolesDetails.forEach((child) => {
                child.checked = false; // Set the 'checked' property to false
            });
        });
    }
    const onSubmit = (e) => {
        e.preventDefault();
        const email_regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
        const name_regex = /^[a-zA-Z]+$/;
        const phone_regex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
        if (!(details.firstname.match(name_regex))) {
            if (!details.firstname) {
                setErrorMessage({ ...errorMessage, contactPersonNameError: "Please enter First Name." });
            }
            else {
                setErrorMessage({ ...errorMessage, contactPersonNameError: "Please enter valid First Name" });
            }
        }
        else if (!(details.mobileNo.match(phone_regex))) {
            if (details.mobileNo.length < 10) {
                setErrorMessage({ ...errorMessage, mobileNoError: "Please enter 10 digit valid mobile number" });
            }
        }
        //else if (getLocalStorageItem("role") != ROLES.ItAdmin && details.mobileNo && !(otpValue)) {
        //    if (mobileOTPValidated === true) {
        //        setErrorMessage({ ...errorMessage, mobileNoError: "" });
        //    }
        //    else setErrorMessage({ ...errorMessage, mobileNoError: "Please verify the mobile number" });
        //}
        else if (!details.govtIdProofNumber) {
            setErrorMessage({ ...errorMessage, govtIdCardNumberError: "Please enter ID Number" });
        }
        else if (!details.govtIdProofType) {
            setErrorMessage({ ...errorMessage, govtIdCardNumberError: "Please select ID Proof Type" });
        }
        else if ((getLocalStorageItem("role") != ROLES.ItAdmin) && details.userType == "External" && (!details.documents || details.documents.length == 0)) {
            setErrorMessage({ ...errorMessage, idProofDocError: "Please upload ID proof document" });

        }
        else if (!(details.emailAddress.match(email_regex))) {
            if (!details.emailAddress) {
                setErrorMessage({ ...errorMessage, idProofDocError: "", emailIdError: "Plase enter Email address." });
            }
            else {
                setErrorMessage({ ...errorMessage, idProofDocError: "", emailIdError: "Please provide valid Email address" });
            }
        }
        else if (allRoles
            ?.flatMap((parent) => parent.RolesDetails)
            ?.filter((child) => child.checked).length == 0) {
            setErrorMessage({ ...errorMessage, idProofDocError: "", roleError: "Please select roles" });
        }
        else {
            setErrorMessage({ ...errorMessage, idProofDocError: "", roleError: "" });
            createUser();
        }

    }

    const onSubmitUpdate = (e, checked) => {
        e.preventDefault();

        if ((details.firstname) && (details.mobileNo) && (details.emailAddress) && (details.govtIdProofType) && (details.govtIdProofNumber)) {
            updateUser();
        }
        else {

            if (!details.govtIdProofNumber) {
                setErrorMessage({ ...errorMessage, govtIdCardNumberError: "Please enter ID Number" });
            }
            if (!details.govtIdProofType) {
                setErrorMessage({ ...errorMessage, govtIdCardNumberError: "Please select ID Proof Type" });
            }
            const name_regex = /^[a-zA-Z]+$/;
            if (!(details.firstname).match(name_regex)) {
                if (!details.firstname) {
                    setErrorMessage({ ...errorMessage, contactPersonNameError: "Please enter First Name." });
                }
                else {
                    setErrorMessage({ ...errorMessage, contactPersonNameError: "Please provide valid Name" });
                }
            }

        }
    }
    useEffect(() => {
        getAllUsers();
        getAllModuleRoles();
    }, [getLocalStorageItem('role')]);

    function getAllUsers() {
        apiClient
            .post(GET_ALL_USERS,
                {
                    "loginId": getLocalStorageItem("role") == ROLES.ItAdmin ? "" : loginUserDetails.adb2c_oid

                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setUserDetails(response.data.users);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const addnewBtnClick = (e) => {
        e.preventDefault();
        setShowGrid(false);
        setShowForm('Add');
        setDetails({
            salutation: 'Mr',
            firstname: '',
            middleName: '',
            lastName: '',
            mobileNo: '',
            gender: 'Male',
            emailAddress: '',
            address: '',
            pincode: '',
            govtIdProofType: 'Aadhaar ID',
            govtIdProofNumber: '',
            id: '',
            selectedPersonalRevenueCircle: '',
            selectedPersonalBlockList: '',
            state: '',
            district: '',
            isActive: '',
            createdOn: '',
            createdBy: '',
            documents: [],
            userType: "External"
        });
        setPincodeAddressDetails(null);
        setCheckedval(false);
        setDisabledval(false);
        setVerifyMobileNo(false);
        setMobileOTPValidated(false);
        allRoles.forEach((parent) => {
            parent.RolesDetails.forEach((child) => {
                child.checked = false; // Set the 'checked' property to false
                child.disabled = false;
                child.actionTaken=null;
                child.approvalStatus=null;
            });
        });
    }

    const editBtnUserClick = (e, item) => {
        e.preventDefault();
        setUserId(item.id);
        setShowGrid(false);
        setShowForm('Edit');
        setMobileOTPValidated(true);
        allRoles.forEach((parent) => {
            parent.RolesDetails.forEach((child) => {
                child.checked = false; // Set the 'checked' property to false
                child.disabled = false;
                child.actionTaken=null;
                child.approvalStatus=null;
            });
        });
        item?.userRoles.forEach((obj) => {
            allRoles.forEach((parent) => {
                parent.RolesDetails.forEach((child) => {
                    if (child.roleId === obj.roleId) {
                        child.checked = true; // Set the 'checked' property to true  
                        child.disabled = (obj.isActive == 4 || (obj.actionTaken == "Deleted" && obj.approvalStatus=="Pending_Approval") ? true : false);
                        child.actionTaken=obj.actionTaken;
                        child.approvalStatus=obj.approvalStatus;
                    }
                });
            });

        });
    }

    const onDeleteUser = () => {
        const tempdata = userDetails.filter((item) => !(item.id === selected.id))

        const deleteData = userDetails.filter((item) => item.id === selected.id)
        // setUserDetails(tempdata)
        setUsersToBeDeleted(deleteData)

        const arr = [...usersToBeDeleted, ...deleteData]

        const dataForApi = arr.map((item) => (
            {
                id: item.id,
                salutation: item.salutation,
                gender: item.gender,
                firstname: item.firstname,
                middlename: item.middlename,
                lastname: item.lastname,
                address: item.address,
                pincode: item.pincode,
                state: item.state,
                district: item.district,
                govtIdProofType: item.govtIdProofType,
                govtIdProofNumber: item.govtIdProofNumber,
                mobileNo: item.mobileNo,
                emailAddress: item.emailAddress,
                isActive: 0,
                userRoles: item.userRoles

            }))
        setUserApiData(dataForApi)
        deleteUserApi(dataForApi);
    };
    const onSubmitApi = (dataForApi) => {

        deleteUserApi(dataForApi);
    }

    const deleteUserApi = (dataForApi) => {
        handleConfirmLogModalClose();
        apiClient
            .post(SAVE_INTERNAL_STAKEHOLDER,
                {
                    "abrplUser": dataForApi?.[0],
                    "loginUserRole": getLocalStorageItem('role'),
                    "loginUserID": getLocalStorageItem('uuid') ? getLocalStorageItem('uuid') : ''
                },

                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                },
            )
            .then((response) => {
                setUpdateUserDetails(response.data);
                getAllUsers();
            })
            .catch(function (error) {
                console.log(error);

            });
    }

    const onToggleClick = (e, params) => {
        if (params?.isActive === 1) {
            setDetails({ ...details, id: params.id, isActive: 2 })
        }
        else {
            setDetails({ ...details, id: params.id, isActive: 1 })
        }
        handleConfirmLogModalOpen();
    }
    function onConfirmCallBack() {
        handleConfirmLogModalClose3();
        if (details) {
            updateUser()
        }
    }
    function onCancelBack() {
        handleConfirmLogModalClose3();

        setUpdatedDetails('');
    }
    const radioChange = (e, value) => {
        allRoles.forEach(item => {
            item.RolesDetails.forEach(roleItem => {
                if (roleItem.roleType !== value && !roleItem.disabled && value=="External") {
                    roleItem.checked = false;
                    roleItem.disabled = false;
                }
               else if(details.userRoles?.filter(item=>item?.roleId==roleItem?.roleId).length>0)
                {
                   roleItem.checked = true;
                }
               });

        });
        setDetails({ ...details, [e.target.name]: value })
    }
    const getBorderColor = (roleItem) => {
        if (roleItem.actionTaken == "Added" && roleItem.approvalStatus == "Pending_Approval") {
            return "green";
        }
        else if (roleItem.actionTaken == "Deleted" && roleItem.approvalStatus == "Pending_Approval") {
            return "red";
        }
        else {
            return "none";
        }
    }
       const getBorderThickness = (roleItem) => {
        if (roleItem.actionTaken == "Added" && roleItem.approvalStatus == "Pending_Approval") {
            return "2px";
        }
        else if (roleItem.actionTaken == "Deleted" && roleItem.approvalStatus == "Pending_Approval") {
             return "2px";
        }
        else {
         return "0px";
        }
    }


    const columns = [
        {
            field: 'firstname', headerName: t('preReg.name'), width: 200,
            valueGetter: (params) => {
                if (params) {
                    return (params.row.firstname + " " + (params.row.middlename ? (params.row.middlename + " ") : "") + (params.row.lastname ? params.row.lastname : ""))
                } else return '-'
            }
        },
        {
            field: 'emailAddress', headerName: t('main.email'), width: 200,
        },
        {
            field: 'roleName', headerName: 'Roles/Status', width: 320,
            valueGetter: (params) => {
                if (params) {
                    return params.row?.userRoles?.map(obj => obj.roleName).join(',\n')
                } else return '-'
            },
            renderCell: (params) => {
                return (
                    <div style={{ whiteSpace: 'pre-line' }}>
                        {params.row?.userRoles?.map(obj => obj.roleName).join(',\n')}
                    </div>
                );
            },
        },
        // {
        //     field: 'userApprovalStatus', headerName: "Status", width: 200,
        // },
        {
            field: 'adb2cOid', headerName: 'Has Signed Up', width: 120,
            valueGetter: (params) => {

                if (params?.row?.adb2cOid != null) {

                    return "Yes"
                } else return 'No'

            }
        },
        {
            field: 'isActive', headerName: 'Active', width: 100,
            renderCell: (params) => {
                return (
                    <Switch
                        disabled={params?.row?.userApprovalStatus == "Pending_Approval" ? true : false}
                        checked={params?.row?.isActive === 1 ? true : false}
                        checkedChildren="Yes"
                        unCheckedChildren="No"
                        onClick={(e) => onToggleClick(e, params?.row)}
                    />
                )
            }
        },
        {
            field: 'resetPassword', headerName: 'Action', width: 250,
            renderCell: (params) => {
                return (
                    <>
                        {/* <Tooltip title="Reset Password"><IconButton color='primary' disabled={params?.row?.isActive == "2" || params?.row?.userApprovalStatus == "Pending_Approval"} onClick={(e) => resetPwBtn(e, params?.row)}><ResetPasswordIcon /></IconButton></Tooltip> */ }
                        <Tooltip title="Send Signup Link"><IconButton color='primary' disabled={params?.row?.isActive == "2"} onClick={(e) => onSendSignUpLink(e, params?.row)}><SignuplinkIcon /></IconButton></Tooltip>
                        <Tooltip title="Edit"><IconButton color='primary' disabled={params?.row?.isActive == "2"} onClick={(e) => editBtnUserClick(e, params?.row)}><EditIcon /></IconButton></Tooltip>
                        <Tooltip title="Delete"><IconButton color='error' disabled={params?.row?.userApprovalStatus == "Pending_Approval" ? true : false} size='small' className='icon_button_grower_pre_reg' aria-label="search" onClick={(e) => confirmDelete(e, params?.row)}><DeleteIcon /></IconButton></Tooltip>
                    </>
                );
            }
        }
    ];

    return (

        <>
            {showGrid === true ?
                <Container fluid>
                    {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG56</p>}
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-start" mb={1}>
                        <Button variant='contained' style={{ alignContent: "end" }} onClick={(e) => addnewBtnClick(e)} startIcon={<AddIcon />}>Add New User</Button>
                    </Stack>
                    {userDetails && userDetails?.filter((item1) => item1.isActive === 1) ?
                        <Box style={{ height: 480, width: '100%' }}>
                            <DataGrid
                                rows={userDetails}
                                columns={columns}
                                pageSize={10}
                                getRowHeight={() => 'auto'}
                                getRowId={(row) => row?.id}
                                components={{ Toolbar: QuickSearchToolbar }}
                            />
                        </Box> : null}
                </Container>
                : null}
            {showForm ?
                <Container maxWidth="xxl">
                    {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>REG57</p>}
                    <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                        {/* <BackButton navigate={navigate} navigateTo="/registrationHome/onboarding"/> */}
                        <Typography variant="h5" gutterBottom>
                            General User Information
                        </Typography>
                    </Stack>
                    <Card>
                        <CardContent>
                            <Grid item xs={12} lg={12} container>
                                <Grid xs={12} lg={5} spacing={1} container>
                                    <Grid item xs={4}>
                                        <FormControl fullWidth>
                                            <InputLabel>Salutation</InputLabel>
                                            <Select name="salutation" label="Salutation" value={details.salutation} onChange={(e) => handleChange(e)}>
                                                {SALUTATION.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.contactPersonNameError}
                                            helperText={errorMessage.contactPersonNameError}
                                            type="text"
                                            label="First Name"
                                            name="firstname"
                                            value={details.firstname}
                                            onChange={(e) => handleChange(e)}
                                            autoComplete="off"
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }} />
                                            <BadgeComponent currentLength={details?.firstname?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField fullWidth
                                            type="text"
                                            label="Middle Name"
                                            name="middlename"
                                            value={details.middlename}
                                            onChange={(e) => handleChange(e)}
                                            autoComplete="off"
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }} />
                                            <BadgeComponent currentLength={details?.middlename?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField fullWidth
                                            type="text"
                                            label="Last Name"
                                            name="lastname"
                                            value={details.lastname}
                                            onChange={(e) => handleChange(e)}
                                            autoComplete="off"
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }} />
                                            <BadgeComponent currentLength={details?.lastname?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControl fullWidth required>
                                            <InputLabel>Gender</InputLabel>
                                            <Select name="gender" label="Gender" value={details.gender} onChange={(e) => handleChange(e)}
                                            >{GENDER.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={verifyMobileNo ? 5 : 8}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.mobileNoError}
                                            helperText={errorMessage.mobileNoError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label="Mobile No."
                                            name="mobileNo"
                                            value={details.mobileNo}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                            disabled={showForm === "Edit" || mobileOTPValidated} />
                                            <BadgeComponent currentLength={details?.mobileNo?.length} maxLength={mobileNoMaxLength} />
                                    </Grid>
                                    {verifyMobileNo &&
                                        <Grid item xs={3}>
                                            <TextField
                                                type="number"
                                                onFocus={handleNumberFieldFocus}
                                                onChange={(e) => onOtpChange(e)}
                                                value={otpValue}
                                                label="Enter OTP"
                                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} />
                                        </Grid>}
                                    <Grid item xs={12}>
                                        {verifyMobileNo === true ?
                                            <div>
                                                <a href='#' className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Resend OTP</a></div>
                                            : mobileOTPValidated === true ? <div hidden={!mobileOTPValidated} className='commonVerifyText'><a href="#">Verified</a>
                                                <img className="commonOtpImg" src={resolveIcon} alt="" /></div> :
                                                <button className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Verify Mobile no.</button>
                                        }
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl className='label_grower_reg' required>
                                            <FormLabel>User Type</FormLabel>
                                            <RadioGroup
                                                row
                                            >
                                                <FormControlLabel control={<Radio name="userType" checked={details?.userType === "Internal"} disabled={stakeholderCategory == STAKEHOLDERTYPE.LLE || stakeholderCategory == STAKEHOLDERTYPE.InterimStorageOperator} onChange={(e) => radioChange(e, 'Internal')} />} label='Internal' />
                                                <FormControlLabel control={<Radio name="userType" checked={details?.userType === "External"} disabled={stakeholderCategory == STAKEHOLDERTYPE.LLE || stakeholderCategory == STAKEHOLDERTYPE.InterimStorageOperator} onChange={(e) => radioChange(e, 'External')} />} label='External' />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid xs={1} lg={1}>
                                </Grid>
                                <Grid item xs={12} lg={5} spacing={1} container>
                                    <Grid item xs={12} lg={12}>
                                        <FormControl fullWidth required>
                                            <InputLabel>ID Proof</InputLabel>
                                            <Select
                                                name="govtIdProofType"
                                                value={details.govtIdProofType}
                                                onChange={(e) => handleChange(e)}
                                                label='ID Proof'>
                                                {GOV_ID_LIST_USER.map((item) => <MenuItem value={item}> {item}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={12}>
                                        <TextField fullWidth required
                                            error={errorMessage.govtIdCardNumberError}
                                            helperText={errorMessage.govtIdCardNumberError}
                                            type={details.govtIdProofType === "Aadhaar ID" ? "number" : "text"}
                                            name="govtIdProofNumber"
                                            inputProps={{
                                                maxLength: details.govtIdProofType === "Aadhaar ID" ? lastFourDigit : 20,
                                              }}
                                            value={details.govtIdProofNumber}
                                            onChange={(e) => handleChange(e)}
                                            autoComplete="off"
                                            label={details.govtIdProofType === "Aadhaar ID" ? "Enter last 4 digits" : details.govtIdProofType === "Voter ID" ? "Enter Voter ID No" : details.govtIdProofType === "Driving Licence" ? "Enter Driving Licence No" : details.govtIdProofType === "Internal Employee ID" ? "Enter Internal Employee ID" : "Enter Bank Passbook No"}
                                            onKeyDown={(evt) => (details.govtIdProofType === "Aadhaar ID" ? evt.key === 'E' || evt.key === 'e' || evt.key === '.' || evt.key === '-' || evt.key === '+' : evt.key === '=' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} />
                                        <BadgeComponent currentLength={details?.govtIdProofNumber?.length} maxLength={details.govtIdProofType === "Aadhaar ID" ? lastFourDigit : 20} />
                                    </Grid>
                                    <Grid item xs={12} lg={12}>
                                        <FileUploadMUI key="IDProof"
                                            documentList={details?.documents}
                                            documentType="IDProof"
                                            callBackDocumentUpload={onUploadCallBack}
                                            stakeholderDetailId={details.id}
                                            title={t('reg.uploadIDProofDoc')}
                                            stakeHolderType="user"
                                            errorMessage={errorMessage}
                                            setErrorMessage={setErrorMessage}
                                            documentError="idProofDocError"
                                        />
                                        {/* <div className='mandatory_field'>{errorMessage.idProofDocError}</div> */}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth required
                                            error={errorMessage.emailIdError}
                                            helperText={errorMessage.emailIdError}
                                            type="text"
                                            label="Email address"
                                            // disabled={showForm === 'Edit'}
                                            name="emailAddress"
                                            inputProps={{
                                                maxLength: emailUrnPassMaxLength,
                                              }}
                                            value={details.emailAddress}
                                            onChange={(e) => handleChange(e)} />
                                            <BadgeComponent currentLength={details?.emailAddress?.length} maxLength={emailUrnPassMaxLength} />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <hr></hr>
                            <Grid item xs={12} lg={12}>
                                <Typography variant='h6'>Roles</Typography>
                                <span className="mandatory_field">{errorMessage.roleError}</span>
                                <div>
                                    <Row xs={12} lg={4}>
                                        {allRoles?.map((item, parentIndex) => {
                                            return (
                                                <>
                                                    <Col>
                                                        <Typography variant='h6' style={{ fontSize: "15px", marginTop: "4px" }}>{item?.moduleName}</Typography>
                                                        <FormGroup>
                                                            {item.RolesDetails.map((roleItem, childIndex) => {
console.log(roleItem);
                                                                return (
                                                                    <>
                                                                        <div style={{border: getBorderThickness(roleItem) , borderStyle: "Solid", borderRadius: "4px", color: getBorderColor(roleItem) }}>
                                                                            <FormControlLabel control={<Checkbox disabled={(details.userType === "External" && roleItem.roleType !== details.userType) || roleItem.disabled} checked={roleItem.checked} onChange={() => checkBoxHandleChange(parentIndex, childIndex, roleItem?.checked)} />} label={roleItem?.childRolesName} />
                                                                        </div>
                                                                    </>
                                                                )
                                                            })}
                                                        </FormGroup>
                                                    </Col>
                                                </>
                                            )
                                        })}
                                    </Row>
                                </div>
                            </Grid>
                        </CardContent>
                    </Card>
                    <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                        <Button sx={{ minWidth: 100 }} variant="outlined" onClick={(e) => onPrevious(e)} startIcon={<CloseIcon />}>Cancel</Button>
                        {
                            showForm === "Edit" ? <Button variant="contained" sx={{ minWidth: 100, ml: "1vh" }} onClick={(e) => onSubmitUpdate(e)} startIcon={<UpdateIcon />}>Update </Button> : <Button variant='contained' sx={{ minWidth: 100, ml: "1vh" }} onClick={(e) => onSubmit(e)} endIcon={<SubmitIcon />}>Submit</Button>}
                    </Box></Container> : null}
            <ConfirmationPopover onConfirm={onDeleteUser} onOpen={logModalOpen3} action="Delete" onClose={handleConfirmLogModalClose} />
            <ConfirmationPopover onConfirm={onConfirmCallBack} onOpen={logConfirmModalOpen} action="Submit" onClose={handleConfirmLogModalClose3} />
        </>
    )
}

export default OnboardingStakeHolderDetails;
